export const getNumber = () => new Date().getTime() + Math.random();
export const getString = () =>
  new Date()
    .getTime()
    .toString()
    .concat((Math.random() * Math.random()).toString(36));
